import React from 'react'
import './index.css'

import Logo from './Logo'
import Chat from './Chat'
import How from './How'
import Why from './Why'
// import PriceList from './PriceList'
import Connect from './Connect'
import Footer from './Footer'

import SnowFall from './SnowFall'
import Overlay from './Overlay'

function App() {
  return (
    <>
      <div className="slogan flex items-center justify-center text-center mt-5 text-gray-600">
        <a href="#what" className="transition duration-300 hover:text-gray-400">
          ЧТО?
        </a>{' '}
        ・{' '}
        <a href="#how" className="transition duration-300 hover:text-gray-400">
          КАК?
        </a>{' '}
        ・
        <a
          href="#for_what"
          className="transition duration-300 hover:text-gray-400"
        >
          ЗАЧЕМ?
        </a>{' '}
        ・{' '}
        {/* <a
          href="#how_much"
          className="transition duration-300 hover:text-gray-400"
        >
          СКОЛЬКО?
        </a>{' '}
        ・{' '}*/}
        <a
          href="#where"
          className="transition duration-300 hover:text-gray-400"
        >
          ГДЕ?
        </a>
      </div>
      <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-800 via-cyan-600 to-green-500 px-5 pt-2 pb-5 rounded-[35px]">
        <SnowFall />
        <Overlay opacity={0.04} />
        <div className="info">
          В чём проблема событий? Посетитель приходит, получает сувениры и
          печатную продукцию и после этого его никак не найти. Для решения этой
          проблемы и был придуман
        </div>
        <Logo />
        <div className="info">
          Гости регистрируются в боте для того, чтобы им отправили их
          фотографии, а у заказчика появляются все их контакты и прямой канал
          связи с ними.
        </div>

        <div id="what" className="info font-bold">
          Что это такое?
        </div>
        <How />
        <div id="how" className="info font-bold">
          Как бот работает? (живой тест)
        </div>
        <Chat />
        <div id="for_what" className="info font-bold pt-5">
          Зачем бот нужен?
        </div>
        <Why />
        {/* <div id="how_much" className="info font-bold">
          Сколько стоит бот?
        </div>
        <PriceList /> */}
        <div id="where" className="info font-bold">
          Где подключиться?
        </div>
        <Connect />
      </div>
      <Footer />
    </>
  )
}

export default App
